import { Component, inject, OnInit } from '@angular/core';
import { Auth } from '../../services/auth';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SuccessDialog } from '../common-features/success-dialog/success-dialog';

@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.html',
  styleUrl: './home.less'
})
export class Home implements OnInit{
  private authService = inject(Auth);
  private _dialog = inject(MatDialog);
  user:any;
  constructor(
    private router:Router
  ){
    this.authService.user.subscribe((x:any)=>this.user = x);
  }
  ngOnInit(): void {
    this.moveToCatalog();
    // this.showSuccessDialogComponent();
  }

  isPrivileged(privilege:string[]){
    const privileges = this.user.privileges;
    const check = privileges.some((x:any)=>privilege.includes(x));
    return check;
  }

  moveToCatalog(){
    // console.log(this.isPrivileged(['IS_BUYER']));
    if(this.isPrivileged(['IS_SELLER_ADMIN'])){
      this.router.navigate(['/seller/seller-catalog'],{ replaceUrl: true })
    }else if(this.isPrivileged(['IS_BUYER'])){
      this.router.navigate(['/buyer/catalog'],{ replaceUrl: true })
    }else if(this.isPrivileged(['IS_INVESTOR'])){
      this.router.navigate(['/investor/market-intelligence'],{ replaceUrl: true })
    }else if(this.isPrivileged(['SUPERADMIN', 'ADMIN'])){
       this.router.navigate(['/admin/master-catalog'],{ replaceUrl: true })
    }
  }

  showSuccessDialogComponent(){
    const dialog = this._dialog.open(SuccessDialog,{
      data:{
        title:'Success!',
        subtitle:'You have successfully registered.'
      },
       height: '400px',
       width: '500px',
      panelClass: 'custom-dialog-container'
    })
    dialog.afterClosed().subscribe((result:any)=>{
      console.log(result);
    })
  }


}
